/**
 * The roster layouts a match opens with. There is no built-in layout for
 * matches: with nothing in Settings → Varsayılan Kadro the roster opens empty,
 * so an emptied default stays empty. Squad types and roles themselves are
 * Settings data — see lib/rosterCatalog.ts; `type` and slot roles here are
 * catalog keys (the built-in catalog keeps the old ids: infantry, sl, tc…).
 */

// ─── Layouts ──────────────────────────────────────────────────────────────────

/** One squad of a layout: its slots are listed by role, in order. */
export interface DefaultSquad { name: string; type: string; slots: string[] }

const inf = (sl: number, rifle: number) => [...Array(sl).fill('sl'), ...Array(rifle).fill('infantry')]

/** The small layout the (retired) Raid Helper event builder opens with. */
export const MINIMAL_LAYOUT: DefaultSquad[] = [
  { name: 'Infantry 1', type: 'infantry', slots: inf(2, 4) },
  { name: 'Armour 1',   type: 'armour',   slots: ['tc', 'driver', 'driver'] },
]

/** Settings → Varsayılan Kadro. Empty when none is saved or on failure. */
export async function fetchRosterDefault(): Promise<DefaultSquad[]> {
  try {
    const r = await fetch('/api/roster-default', { credentials: 'include' })
    if (!r.ok) return []
    const d = await r.json()
    return Array.isArray(d?.squads) ? d.squads : []
  } catch {
    return []
  }
}
